export default "__VITE_ASSET__DIvaVMDR__"